var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoLoginAdminWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "auto",
    id: "npqc838xoc"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 9.200000 0 0 0 0 9.200000 0 0 0 0 9.200000 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-100 -71)",
    filter: "url(#npqc838xoc)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#B6BFCE"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.429 90.429c-.838-.701-2.066-1.143-3.435-1.143-1.362 0-2.585.438-3.423 1.133",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.994 82.429a2.495 2.495 0 0 1 2.493 2.492 2.495 2.495 0 0 1-2.493 2.493 2.495 2.495 0 0 1-2.492-2.493 2.495 2.495 0 0 1 2.492-2.492z",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.859 88.008a7.8 7.8 0 0 0 .074-1.008 7.8 7.8 0 0 0-.074-1.008l2.231-1.697a.51.51 0 0 0 .127-.658l-2.115-3.56c-.127-.226-.412-.308-.645-.226l-2.633 1.029a7.78 7.78 0 0 0-1.787-1.008l-.402-2.726a.511.511 0 0 0-.518-.432h-4.23a.511.511 0 0 0-.518.432l-.401 2.726a8.182 8.182 0 0 0-1.788 1.008l-2.633-1.029a.523.523 0 0 0-.645.227l-2.114 3.559a.498.498 0 0 0 .126.658l2.232 1.697c-.043.33-.074.669-.074 1.008 0 .34.031.679.074 1.008l-2.232 1.697a.51.51 0 0 0-.126.658l2.114 3.56c.127.226.413.308.645.226l2.633-1.029a7.78 7.78 0 0 0 1.788 1.008l.401 2.726a.511.511 0 0 0 .518.432h4.23a.511.511 0 0 0 .518-.432l.402-2.726a8.182 8.182 0 0 0 1.787-1.008l2.633 1.029c.243.092.518 0 .645-.227l2.115-3.559a.51.51 0 0 0-.127-.658l-2.231-1.697z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoLoginAdminWhite);
export default __webpack_public_path__ + "static/media/ico-login-admin-white.5c91b32a8460fbe256a7381aee148010.svg";
export { ForwardRef as ReactComponent };